//
//
//
//
export default {
  head: {
    htmlAttrs: {
      class: 'theme-light'
    }
  }
};